import React, { useEffect } from 'react';
import { Target, Calendar, Check, Lightbulb, ArrowDown, ArrowRight } from 'lucide-react';
export function LlamadasSemanalesCursoPage() {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#7FFF00]/20 selection:text-[#7FFF00]" data-id="element-3184">
      <main className="max-w-4xl mx-auto px-4 py-12 md:py-20" data-id="element-3185">
        {/* HERO SECTION */}
        <section className="text-center space-y-6 mb-12 md:mb-16" data-id="element-3186">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#7FFF00]/10 border border-[#7FFF00]/30 mb-2" data-id="element-3187">
            <Target className="w-8 h-8 text-[#7FFF00]" data-id="element-3188" />
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight" data-id="element-3189">
            Únete a las Llamadas Semanales con Gabriel Beltrán
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 font-medium max-w-2xl mx-auto" data-id="element-3190">
            ¿Listo para construir un negocio digital que genere ingresos reales?
          </p>

          <p className="text-lg text-gray-400" data-id="element-3191">
            Agenda tu llamada y elige el plan que mejor se adapte a ti:
          </p>
        </section>

        {/* PRICING PLANS */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12 md:mb-16" data-id="element-3192">
          {/* Plan 3 Meses */}
          <div className="bg-gray-900/40 border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col transition-transform hover:-translate-y-1 duration-300" data-id="element-3193">
            <div className="flex items-center gap-3 mb-6 pb-6 border-b border-gray-800" data-id="element-3194">
              <div className="bg-gray-800 p-3 rounded-lg" data-id="element-3195">
                <Calendar className="w-6 h-6 text-white" data-id="element-3196" />
              </div>
              <div data-id="element-3197">
                <h2 className="text-2xl font-bold text-white" data-id="element-3198">Plan 3 Meses</h2>
                <p className="text-[#7FFF00] font-black text-xl" data-id="element-3199">$997</p>
              </div>
            </div>

            <ul className="space-y-4 flex-1" data-id="element-3200">
              <li className="flex items-start gap-3" data-id="element-3201">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3202" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3203">
                  Llamadas semanales en vivo con Gabriel Beltrán
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-3204">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3205" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3206">
                  Acceso completo al curso{' '}
                  <strong className="text-white" data-id="element-3207">Info Commerce Academy</strong>{' '}
                  (valorado en $2,000)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-3208">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3209" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3210">
                  Aprende Print on Demand y mucho más
                </span>
              </li>
            </ul>
          </div>

          {/* Plan 6 Meses (Highlighted) */}
          <div className="bg-gray-900/60 border-2 border-[#7FFF00]/50 rounded-2xl p-6 md:p-8 flex flex-col relative shadow-[0_0_30px_rgba(127,255,0,0.1)] transition-transform hover:-translate-y-1 duration-300" data-id="element-3211">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-[#7FFF00] to-[#6FEF00] text-black text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest shadow-lg" data-id="element-3212">
              Recomendado
            </div>

            <div className="flex items-center gap-3 mb-6 pb-6 border-b border-gray-800" data-id="element-3213">
              <div className="bg-[#7FFF00]/10 p-3 rounded-lg" data-id="element-3214">
                <Calendar className="w-6 h-6 text-[#7FFF00]" data-id="element-3215" />
              </div>
              <div data-id="element-3216">
                <h2 className="text-2xl font-bold text-white" data-id="element-3217">Plan 6 Meses</h2>
                <p className="text-[#7FFF00] font-black text-xl" data-id="element-3218">$1,997</p>
              </div>
            </div>

            <ul className="space-y-4 flex-1" data-id="element-3219">
              <li className="flex items-start gap-3" data-id="element-3220">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3221" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3222">
                  Llamadas semanales en vivo con Gabriel Beltrán
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-3223">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3224" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3225">
                  Acceso completo al curso{' '}
                  <strong className="text-white" data-id="element-3226">Info Commerce Academy</strong>{' '}
                  (valorado en $2,000)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-3227">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3228" />
                <span className="text-gray-300 leading-relaxed" data-id="element-3229">
                  Aprende Print on Demand y mucho más
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-3230">
                <Check className="w-5 h-5 text-[#7FFF00] shrink-0 mt-0.5" data-id="element-3231" />
                <span className="text-white font-medium leading-relaxed" data-id="element-3232">
                  El doble de tiempo para implementar, crecer y escalar
                </span>
              </li>
            </ul>
          </div>
        </section>

        {/* VALUE PROPOSITION */}
        <section className="bg-gray-900/50 border border-gray-800 rounded-2xl p-8 md:p-10 text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-3233">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-yellow-500/10 mb-4" data-id="element-3234">
            <Lightbulb className="w-6 h-6 text-yellow-500" data-id="element-3235" />
          </div>
          <p className="text-xl md:text-2xl font-bold text-white mb-3" data-id="element-3236">
            Todo esto por menos de lo que vale solo el curso.
          </p>
          <p className="text-lg text-gray-400" data-id="element-3237">
            No es solo información. Es acompañamiento, estrategia y resultados.
          </p>
        </section>

        {/* CTA SECTION */}
        <section className="text-center space-y-8 max-w-2xl mx-auto mb-16" data-id="element-3238">
          <div className="flex flex-col items-center gap-4" data-id="element-3239">
            <ArrowDown className="w-8 h-8 text-[#7FFF00] animate-bounce" data-id="element-3240" />
            <h2 className="text-2xl md:text-3xl font-bold" data-id="element-3241">
              Agenda tu llamada ahora y empieza a jugar en otro nivel.
            </h2>
          </div>

          <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-implementacion" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-b from-[#7FFF00] to-[#6FEF00] hover:from-[#6FEF00] hover:to-[#5FDF00] text-black font-black text-lg md:text-xl rounded-xl py-5 px-8 shadow-[0_0_20px_rgba(127,255,0,0.3)] hover:shadow-[0_0_30px_rgba(127,255,0,0.5)] transition-all duration-300 transform hover:scale-[1.02]" data-id="element-3242">
            <span className="flex items-center justify-center gap-3" data-id="element-3243">
              RESERVA TU LUGAR AQUÍ
              <ArrowRight className="w-6 h-6" data-id="element-3244" />
            </span>
          </a>
        </section>
      </main>

      {/* FOOTER */}
      <footer className="bg-black border-t border-gray-800 py-8 md:py-12" data-id="element-3245">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-3246">
          <div className="mb-6" data-id="element-3247">
            <p className="text-[#7FFF00] font-bold text-lg md:text-xl mb-2" data-id="element-3248">
              48HRSCASHMACHINE.COM
            </p>
          </div>

          <div className="text-gray-400 text-xs md:text-sm leading-relaxed space-y-3" data-id="element-3249">
            <p data-id="element-3250">
              Derechos de autor © 2025, 48 Hrs AI Cash Machine: Todos los
              derechos reservados.
            </p>
            <p className="text-gray-500" data-id="element-3251">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#7FFF00] hover:text-[#6FEF00] transition-colors" data-id="element-3252">
                support@truemarketer.com
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>;
}